import { Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  currentPath = signal<string>('');
  currentRoute = signal<string>('');

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const paths: string[] = event.url.split('/');
        this.currentPath.set(paths[paths.length - 1]);
        this.currentRoute.set(event.url);
      });
  }
}
